function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Folders---Tooltip-3",
  transform: "translate(-543.000000, -188.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path",
  transform: "translate(280.000000, 169.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(15.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(195.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60.1014356,9.10871507 L55.3211005,4.32838 C54.8832605,3.89054 54.1656617,3.89054 53.7278217,4.32838 L53.3288787,4.72732304 C52.8910387,5.16466436 52.8910387,5.88226317 53.3288787,6.32010316 L56.9762155,9.96843733 L53.32838,13.6162728 C52.89054,14.0541128 52.89054,14.7717116 53.32838,15.2090529 L53.727323,15.607996 C54.165163,16.0463347 54.8827618,16.0463347 55.3206018,15.607996 L60.1009369,10.8271622 C60.3363133,10.5922845 60.4410359,10.2771195 60.4235821,9.96793866 C60.4415345,9.65925647 60.336812,9.34409147 60.1014356,9.10871507 Z",
  id: "Shape"
}))))));

var SvgChevronThick = function SvgChevronThick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "12px",
    viewBox: "0 0 8 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronThick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ChevronThick.0cd60c21.svg";
export { ForwardRef as ReactComponent };